<fgb-mobile-nav-menu></fgb-mobile-nav-menu>
<div class="banner d-lg-block d-none" role="banner">
  <h1>{{ 'ticket.transfer.page.title' | translate }}</h1>
</div>

<div class="mobile-container">
  <div class="container mt-4">
    <div class="mb-4">
      <fgbcl-contact-management-widget></fgbcl-contact-management-widget>
    </div>
    <fgbcl-games-with-tickets-list></fgbcl-games-with-tickets-list>
  </div>
</div>
